import { render, staticRenderFns } from "./zone-form.vue?vue&type=template&id=5b7468d4&"
import script from "./zone-form.vue?vue&type=script&lang=ts&"
export * from "./zone-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports